export default __webpack_public_path__ + "static/media/6.8a439c6a.jpg";